import { render, staticRenderFns } from "./Engineering.vue?vue&type=template&id=2dff2582&scoped=true"
import script from "./Engineering.vue?vue&type=script&lang=js"
export * from "./Engineering.vue?vue&type=script&lang=js"
import style0 from "./Engineering.vue?vue&type=style&index=0&id=2dff2582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff2582",
  null
  
)

export default component.exports